import React from "react";
import { Link } from 'react-router-dom'
import SectionTitle from "../SectionTitle/SectionTitle";
import Services from "../../api/Services";




const ServiceSection = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const { SectionTitleShow = true, ServiceAllBtn = true } = props




    return (
        <div className={"" + props.hclass}>
            <div className="container">
                <div className="row align-items-end">
                    <div className="col-lg-7 col-12">
                        {SectionTitleShow && (
                            <SectionTitle subtitle={'Integrated Supply Solutions'} title={'Our Services'} />
                        )}
                    </div>
                    <div className="col-lg-5 col-12">
                        {ServiceAllBtn && (
                            <div className="service-all-btn">
                                <Link onClick={ClickHandler} to="/services" className="theme-btn">All Services</Link>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                {/* <Slider {...settings} className="service-slider">
                    {Services.slice(0, 9).map((service, item) => (
                        <div className="service-card" key={item}>
                            <img className="image" src={service.image} alt="" />
                            <div className="content">
                                <i className={service.iconName}></i>
                                <div className="text">
                                    <span>{service.id}</span>
                                    <h2><Link to={`/services/${service.slug}`} onClick={ClickHandler}>{service.title}</Link></h2>
                                    <p>{service.description}</p>
                                    <Link to={`/services/${service.slug}`} onClick={ClickHandler} className="service-single-link">
                                        <i className="flaticon-right-arrow"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider> */}


                <div className="row gy-md-0 gy-4">
                    {Services.slice(0, 3).map((service, item) => (
                        <div className="col-md-4">
                            <div className="service-card" key={item}>
                                <div className="servic-image">
                                    <img className="image" src={service.image} alt="" />
                                </div>
                                <div className="content pt-4">
                                    {/* <i className={service.iconName}></i> */}
                                    <div className="text">
                                        <span>{service.id}</span>
                                        <h2><Link to={`/services/${service.slug}`} onClick={ClickHandler}>{service.title}</Link></h2>
                                        <p>{service.description}</p>
                                        <Link to={`/services/${service.slug}`} onClick={ClickHandler} className="service-single-link">
                                            <i className="flaticon-right-arrow"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}


                </div>
            </div>

        </div>

    );
}

export default ServiceSection;



